import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
    getNameDay,
    getTekDay,
    getTime,
} from 'src/app/components/application/global.function';
import { IHistoryEvents } from 'src/app/interfaces/history.interface';
import { DicomViewModalComponent } from '../../dicom-view-modal/dicom-view-modal.component';
import { ConfigService } from 'src/app/services/application/config.service.';
import { lastValueFrom } from 'rxjs';
import { HttpNewService } from 'src/app/services/application/http-new.service';
import { SemdModalComponent } from 'src/app/modals/semd-modal/semd-modal.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'semd-view',
    templateUrl: './semd-view.component.html',
    styleUrls: ['./semd-view.component.scss'],
})
export class SemdViewComponent {
    @Input() visit!: IHistoryEvents;
    txtPhone = '8 800 555 666';
    pdfImageURL = 'assets/img/svg/pdf-view.svg';
    showFilials = true;
    pdfLoading = false;
    safeHtml: SafeHtml[] = [];
    constructor(
        private modalService: NgbModal,
        private configS: ConfigService,
        private http: HttpNewService,
        private sanitizer: DomSanitizer
    ) {}

    protected async goPreview(id: number, tp: string, $event: MouseEvent) {
        $event.stopPropagation();
        this.pdfLoading = true;
        const res: string = await lastValueFrom(
            this.http.get(`/history/events/item/semd?tp=${tp}&id=${id}&isNeedPdf=0&sort=0`)
        );
        for (const part of res) {
            this.safeHtml.push(this.sanitizer.bypassSecurityTrustHtml(part));
        }
        const modal = this.modalService.open(SemdModalComponent, {
            size: 'large',
        });
        modal.componentInstance.data = this.safeHtml;
        this.pdfLoading = false;
    };

    protected async gotToDownload(id: number, tp: string, $event: MouseEvent) {
        $event.stopPropagation();
        this.pdfLoading = true;
        const res: string = await lastValueFrom(
            this.http.get(`/history/events/item/semd?tp=${tp}&id=${id}&isNeedPdf=1&sort=0`)
        );
        this.pdfLoading = false;
        return this.printPdf(res);
    };

    protected openDicomModal(
        accessionNumber: string,
        studyDate: string,
        studyInstanceUID: string,
        e: MouseEvent
    ) {
        e.stopPropagation();
        const modal = this.modalService.open(DicomViewModalComponent);
        modal.componentInstance.accessionNumber = accessionNumber;
        modal.componentInstance.studyDate = studyDate
            .match(/(\d{0,4})(\d{0,2})(\d{0,2})/)
            ?.splice(1, 4)
            .reverse()
            .join('.');
        modal.componentInstance.studyInstanceUID = studyInstanceUID;
    }
    protected getDownloadUrl(studyIUID: string): string {
        return (
            this.configS.getValue('hostBackend') +
            `/history/visit/dicom/download?studyIUID=${studyIUID}`
        );
    }

    protected getTekDay(dt: Date): string {
        return getTekDay(dt);
    }

    protected getTime(dt: Date): string {
        return getTime(dt);
    }

    protected getNameDay(dt: Date): string {
        return getNameDay(dt);
    }
    protected stopPropagation(e: MouseEvent) {
        e.stopPropagation();
    }
    private printPdf(blob: string): void {
        const cleanBase64 = blob.replace(/^data:application\/pdf;base64,/, '');
        const binaryString = atob(cleanBase64);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const file = new Blob([bytes], {
            type: 'application/pdf',
            endings: 'native'
        });
        const fileURL = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = fileURL;
        link.type = 'application/pdf';
        link.download = 'document.pdf'
        link.rel = 'noopener noreferrer';
        document.body.appendChild(link );
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(fileURL), 60_000);
    }
}
